import { object, string } from 'yup';

export interface RecoverCodeProps {
  password: string;
  passwordCompare: string;
  token: string;
}

export const RecoverCodeSchema = object().shape({
  password: string()
    .min(8, 'errors.password is too short')
    .required('errors.password is required'),
  passwordCompare: string()
    .min(8, 'errors.password is too short')
    .required('errors.password is required')
    .test(
      'password',
      'errors.password must be confirmed',
      /* eslint-disable func-names */ function(passwordCompare) {
        return passwordCompare === this.parent.password;
      }
    ),
  token: string().required('errors.recover code is required')
});
